import { toast } from 'sonner'
import { useState } from 'react'

import { useLocales } from 'src/contexts'

import { serviceTypeDictionary } from 'src/helpers/serviceTypeDictionaryForContacts'

import { UseInfoContactWindowProps } from 'src/pages/ServiceContactsHistory/types'
import { getFormFields } from 'src/pages/ServiceContacts/helpers'
import { COPY_RESET_DELAY } from 'src/features/InfoContactWindow/constants'

export const useInfoContactWindow = ({
  toggle,
  toggleEditMode,
}: UseInfoContactWindowProps) => {
  const { translations } = useLocales()
  const [copied, setCopied] = useState<string | null>(null)

  const handleCopy = (value: string): void => {
    navigator.clipboard.writeText(String(value))
    setCopied(value)
    toast(translations.serviceContacts.historyServiceContacts.toast.copy.title)

    setTimeout(() => setCopied(null), COPY_RESET_DELAY)
  }

  const handleClick = (id: string) => {
    toggle()
    toggleEditMode(id)
  }

  return {
    listOfFields: getFormFields(translations.serviceContacts),
    title:
      translations.serviceContacts.historyServiceContacts.contactInfoWindow
        .title,
    close:
      translations.serviceContacts.historyServiceContacts.contactInfoWindow
        .close,
    handleCopy,
    serviceTypeDictionary: serviceTypeDictionary(translations.serviceContacts),
    copied,
    handleClick,
  }
}
